import React from "react";

import WeatherCard from "components/cards/metrics/WeatherCard.component";
import { getTrend } from "constants/metrics";
import { useTranslation } from "react-i18next";

const MetricCard = (props) => {
  const {
    label,
    loading,
    data,
    min,
    max,
    mean,
    isTrend = true,
    symbol = "",
  } = props;
  const { t } = useTranslation();

  return isTrend ? (
    <WeatherCard
      isLoading={loading}
      label={label}
      {...props}
      mean={
        data === null || data?.data === null || data?.data === undefined
          ? t("Absent data")
          : `${data?.data} ${symbol}`
      }
      trend={data?.trend ? getTrend(data?.trend, t) : ""}
    />
  ) : (
    <WeatherCard
      isLoading={loading}
      label={label}
      {...props}
      min={min !== null && `${min}${symbol}`}
      max={max !== null && `${max}${symbol}`}
      mean={
        mean === null || mean === undefined
          ? t("Absent data")
          : `${mean}${symbol}`
      }
    />
  );
};

export default MetricCard;
